<template>
    <div class="form-input">
        <label class="checkbox" :class="{disabled, error}">
            <input
                type="checkbox"
                :name="name"
                value="true"
                :id="id"
                :disabled="disabled"
                :checked="value"
                @input="$emit('input', $event.target.checked)"
                @change="$emit('change', $event.target.checked)"
            >

            <div class="box elevate align-self-baseline">
                <div class="icon-ic-tick"></div>
            </div>

            <div class="text">
                <slot></slot>
            </div>
        </label>

        <transition name="smooth">
            <div
                class="feedback color-red f-small"
                v-if="error"
            >
                <div class="mt-1">{{error}}</div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    props: ['value', 'name', 'id', 'disabled', 'error'],

    methods: {
        presskey ($event) {
            if ($event.keyCode === 13) $event.target.click();
        }
    }
}
</script>
